import { Container, Divider, Heading } from '@chakra-ui/react';
import CardForm from 'components/ui/CardForm';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import UserForm from '../components/UserForm';

export default function PageCreateUser() {
  return (
    <>
      <HeaderBarInternal
        title="Novo usuário"
        backTo="/usuarios"
      />
      <Divider />

      <Container 
        variant="internal"
        flexDirection="column"
      >
        <Heading as="h1" size="h1">
          Dados do usuário
          <span>Identifique um novo usuário Patri</span>
        </Heading>

        <CardForm>
          <UserForm />
        </CardForm>
      </Container>
    </>
  )
}
